import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setClickCount, setCurrentStep } from '../../redux/actions';
import { TbBulb } from 'react-icons/tb';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { makeAjax, respStatus, showMessage, url } from '../../helpers/global_helper';
// import { makeAjax, respStatus, showMessage, url } from '../../helpers/global_helper';

function CoachMarkPopup() {
    const dispatch = useDispatch()
    const currentStep = useSelector((state) => state.paginationData.currentStep)
    const clickStep = useSelector((state) => state.paginationData.clickStep)
    const isSettingCoachMark = useSelector((state) => state.paginationData.isSettingCoachMark)
    const device = useSelector((state) => state.CommonConfig.device_type);
    const depositUrl = sessionStorage.getItem("depositUrl");

    const coachDataDesktop = {
        "0": {
            "step": "1",
            "headerEng": "Language Icon",
            "descriptionEng": "Click on the Language Button to switch language.",
            "headerIndo": "Ikon Bahasa",
            "descriptionIndo": "Tekan Tombol untuk beralih antar Bahasa.",
        },
        "1": {
            "step": "2",
            "headerEng": "Coin Reward",
            "descriptionEng": "Click on the  Reward Button to Claim coin rewards.",
            "headerIndo": "Koin Reward",
            "descriptionIndo": "Tekan Tombol Koin Reward untuk mengklaim hadiah koin.",
        },
        "2": {
            "step": "3",
            "headerEng": "Information",
            "descriptionEng": "Access all your betting transactions and invoices in one place.",
            "headerIndo": "Informasi",
            "descriptionIndo": "Akses semua transaksi dan data taruhan Anda di sini.",
        },
        "3": {
            "step": "4",
            "headerEng": "Notifications",
            "descriptionEng": "Stay updated with all your notifications in here.",
            "headerIndo": "Notifikasi",
            "descriptionIndo": "Dapatkan Notifikasi tentang informasi terkini disini.",
        },
        "4": {
            "step": "5",
            "headerEng": "Logout",
            "descriptionEng": "Click on logout to return to the Website.",
            "headerIndo": "Keluar",
            "descriptionIndo": "Klik Keluar untuk kembali ke website.",
        },
        "5": {
            "step": "6",
            "headerEng": "Balance Refresh",
            "descriptionEng": "Click on refresh to update and view your current balance.",
            "headerIndo": "Update saldo",
            "descriptionIndo": "Klik update saldo untuk memperbarui dan melihat saldo Anda saat ini.",
        },
        "6": {
            "step": "7",
            "headerEng": "All Games",
            "descriptionEng": "Click the All Permainan icon to browse all available DingDong games in one place.",
            "headerIndo": "Semua Permainan",
            "descriptionIndo": "Klik ikon Semua Permainan untuk menelusuri semua Permainan DingDong yang tersedia.",
        },
        "7": {
            "step": "8",
            "headerEng": "Game Icon",
            "descriptionEng": "Player can choose any specific game to play.",
            "headerIndo": "Ikon Permainan",
            "descriptionIndo": "Pemain dapat memilih permainan tertentu untuk dimainkan.",
        },

        "8": {
            "step": "10",
            "headerEng": "Game Tiles",
            "descriptionEng": "Choose on a game tile to view its history and start playing.",
            "headerIndo": "Pilih Permainan",
            "descriptionIndo": "Pilih permainan untuk melihat riwayatnya dan mulai bermain.",
        },
        "9": {
            "step": "10",
            "headerEng": "Search Box",
            "descriptionEng": "Use the Games search box to quickly find your favorite games.",
            "headerIndo": "Kotak Pencarian",
            "descriptionIndo": "Gunakan kotak Pencarian Permainan untuk menemukan Permainan favorit Anda.",
        },
        "10": {
            "step": "11",
            "headerEng": "Grid View",
            "descriptionEng": "Click on the Grid view to organize and view games in a grid layout for easier browsing.",
            "headerIndo": "Tampilan Grid",
            "descriptionIndo": "Klik pada tampilan Grid untuk mengatur dan melihat Permainan dalam tata letak Grid.",
        },
        "11": {
            "step": "12",
            "headerEng": "Multi Bet",
            "descriptionEng": "Click on the Multi bet icon to play up to multiple games.",
            "headerIndo": "Multi Taruhan",
            "descriptionIndo": "Klik ikon Multi Taruhan untuk memainkan beberapa permainan.",
        },
        "12": {
            "step": "13",
            "headerEng": "Multi Bet",
            "descriptionEng": "Under the *Multi Bet* tab, select at least two games to play simultanously.",
            "headerIndo": "Multi Taruhan",
            "descriptionIndo": "Di bawah tab *Multi Taruhan*, pilih setidaknya dua permainan untuk dimainkan secara bersamaan.",
        },
        "13": {
            "step": "14",
            "headerEng": "Top Up Balance",
            "descriptionEng": "Click this button to make a deposit.",
            "headerIndo": "Tambah Saldo",
            "descriptionIndo": "Klik tombol ini untuk melakukan deposit.",
        },
        "skipAllEng": "SKIP ALL",
        "nextEng": "NEXT",
        "doneEng": "DONE",
        "closeEng": "CLOSE",
        "skipAllIndo": "LEWATI",
        "nextIndo": "BERIKUT",
        "doneIndo": "SELESAI",
        "closeIndo": "TUTUP",
    }

    const coachDataMobile = {
        "0": {
            "step": "1",
            "headerEng": "All Games",
            "descriptionEng": "Click on the *All Games* icon to browse all available Ding Dong games in one place.",
            "headerIndo": "Semua Permainan",
            "descriptionIndo": "Ketuk ikon Semua Permainan untuk menelusuri semua Permainan DingDong yang tersedia.",
        },
        "1": {
            "step": "2",
            "headerEng": "Search Box",
            "descriptionEng": "Use the *Game Search* box to quickly find your favorite games.",
            "headerIndo": "Kotak Pencarian",
            "descriptionIndo": "Gunakan kotak Pencarian Permainan untuk menemukan Permainan favorit Anda.",
        },
        "2": {
            "step": "3",
            "headerEng": "Grid View",
            "descriptionEng": "Click on the Grid view to organize and view games in a grid layout for easier browsing .",
            "headerIndo": "Tampilan Grid",
            "descriptionIndo": "Klik pada tampilan Grid untuk mengatur dan melihat Permainan dalam tata letak grid.",
        },
        "3": {
            "step": "4",
            "headerEng": "Game Tiles",
            "descriptionEng": "Click on a game tile to view its history and start playing.",
            "headerIndo": "Pilih Permainan",
            "descriptionIndo": "Pilih permainan untuk melihat riwayatnya dan mulai bermain.",
        },
        "4": {
            "step": "5",
            "headerEng": "Balance Refresh",
            "descriptionEng": "Click on refresh to update and view your current balance.",
            "headerIndo": "Update Saldo",
            "descriptionIndo": "Klik update saldo untuk memperbarui dan melihat saldo Anda saat ini.",
        },
        "5": {
            "step": "6",
            "headerEng": "Language Icon",
            "descriptionEng": "Click the Language button to switch between Indonesion to English .",
            "headerIndo": "Ikon Permainan",
            "descriptionIndo": "Tekan Tombol untuk beralih antar Bahasa.",
        },
        "6": {
            "step": "7",
            "headerEng": "Hamburger Menu",
            "descriptionEng": "Click on the Hamburger Menu to explore more options and navigate seamlessly.",
            "headerIndo": "Hamburger",
            "descriptionIndo": "Ketuk Menu Hamburger untuk menjelajahi lebih banyak opsi dan menavigasi dengan lancar.",
        },
        "7": {
            "step": "8",
            "headerEng": "Coin Rewards",
            "descriptionEng": "Click on rewards button to claim coin rewards.",
            "headerIndo": "Koin Reward",
            "descriptionIndo": "Tekan Tombol Hadiah untuk mengklaim hadiah koin.",
        },
        "8": {
            "step": "9",
            "headerEng": "Logout",
            "descriptionEng": "Click on logout to return to the Website.",
            "headerIndo": "Keluar",
            "descriptionIndo": "Klik Keluar untuk kembali ke website.",
        },
        "9": {
            "step": "10",
            "headerEng": "Home",
            "descriptionEng": "Click the Home Button to navigate back to the homepage.",
            "headerIndo": "Rumah",
            "descriptionIndo": "Klik Tombol Beranda untuk menavigasi kembali ke beranda.",
        },
        "10": {
            "step": "11",
            "headerEng": "Information",
            "descriptionEng": "Access all your betting transactions and invoices in one place.",
            "headerIndo": "Informasi",
            "descriptionIndo": "Akses semua transaksi dan data taruhan Anda di sini.",
        },
        "11": {
            "step": "12",
            "headerEng": "Notification",
            "descriptionEng": "Stay update with all your dingdong game lobby notifications here.",
            "headerIndo": "Notifikasi",
            "descriptionIndo": "Dapatkan Notifikasi tentang informasi terkini disini.",
        },
        "12": {
            "step": "13",
            "headerEng": "Top Up Balance",
            "descriptionEng": "Click this button to make a deposit.",
            "headerIndo": "Tambah Saldo",
            "descriptionIndo": "Klik tombol ini untuk melakukan deposit.",
        },
        "skipAllEng": "SKIP ALL",
        "nextEng": "NEXT",
        "doneEng": "DONE",
        "closeEng": "CLOSE",
        "skipAllIndo": "LEWATI",
        "nextIndo": "BERIKUT",
        "doneIndo": "SELESAI",
        "closeIndo": "TUTUP",
    }

    // const valueDone = device == "Mobile" ? 12 : 13; // Number of steps in the coachmark sequence
    const valueDone = device === "Mobile"
        ? (depositUrl ? 12 : 11)  // 11 = previous step before 12
        : (depositUrl ? 13 : 12); // 12 = previous step before 13

    const language = localStorage.getItem('I18N_LANGUAGE') || 'id';

    const handleNext = () => {

        // Check if the device is in landscape mode and the height is less than 450
        const isLandscape = window.matchMedia("(orientation: landscape)").matches;
        const isHeightLessThan450 = window.innerHeight < 450;


        // Old Logic for working properly  
        // if ((device === 'Mobile' && currentStep === 7) && isLandscape && isHeightLessThan450) {
        //     dispatch(setCurrentStep(currentStep + 2)); // Reset Redux state
        //     dispatch(setClickCount(clickStep + 2));
        // }
        // else {
        //     dispatch(setCurrentStep(currentStep + 1)); // Reset Redux state
        //     dispatch(setClickCount(clickStep + 1));
        // }

        //== Not in use
        // dispatch(setCurrentStep(currentStep + 1));
        // dispatch(setClickCount(clickStep + 1))
        //== Not in use

        // New Logic to skip deposit step
        if (
            (device === "Mobile" && currentStep === 11 && !depositUrl) ||
            (device === "Desktop" && currentStep === 12 && !depositUrl)
        ) {
            dispatch(setCurrentStep(currentStep + 2));
            dispatch(setClickCount(clickStep + 2));
        } else if ((device === 'Mobile' && currentStep === 7) && isLandscape && isHeightLessThan450) {
            dispatch(setCurrentStep(currentStep + 2));
            dispatch(setClickCount(clickStep + 2));
        } else {
            dispatch(setCurrentStep(currentStep + 1));
            dispatch(setClickCount(clickStep + 1));
        }
        // New Logic to skip deposit step

    };

    useEffect(() => {
        const isLandscape = window.matchMedia("(orientation: landscape)").matches;
        const isHeightLessThan450 = window.innerHeight < 450;
    }, [])

    const handleDone = () => {
        // dispatch(setCurrentStep(-1)); // Close the popup on "Done"
        // dispatch(setClickCount(clickStep + 1))

        if (isSettingCoachMark === false) {
            // Call API to update CoachMark status
            makeAjax(url.PLAYER_API.updateCoachMarkStatus, {}, url.PLAYER_MS_EXT)
                .then((response) => {
                    if (response.status !== respStatus["SUCCESS"]) {
                        showMessage(response);
                        return;
                    }
                    dispatch(setCurrentStep(-1));
                    dispatch(setClickCount(1));
                })
                .catch((error) => {
                    console.error("Error updating CoachMark status:", error);
                });
        } else {
            dispatch(setCurrentStep(-1));
            dispatch(setClickCount(1));
        }
    };

    // If `currentStep` is -1, do not render the CoachMarkPopup
    if (currentStep === -1) {
        return null;
    }

    return (
        <>{
            device === "Desktop" ? (
                <div className="custom-tooltip"
                    onClick={(e) => e.stopPropagation()} // Prevent event bubbling
                >
                    <div className="quick-tip">
                        <TbBulb /><span>{`Quick tip ${clickStep}`}/{depositUrl ? 14 : 13}</span>
                    </div>
                    <div className="text">
                        {language === 'id'
                            ? coachDataDesktop[currentStep]?.headerIndo
                            : coachDataDesktop[currentStep]?.headerEng
                        }
                    </div>
                    <p className="market-bet">
                        {language === 'id'
                            ? coachDataDesktop[currentStep]?.descriptionIndo
                            : coachDataDesktop[currentStep]?.descriptionEng
                        }
                    </p>
                    <div className="custom-action">
                        {currentStep < valueDone ? (
                            <>
                                <div className="custom-bet" onClick={handleDone}>
                                    {language === 'id'
                                        ? coachDataDesktop.skipAllIndo
                                        : coachDataDesktop.skipAllEng
                                    }
                                </div>
                                <div className="custom-bet" onClick={handleNext}>
                                    {language === 'id'
                                        ? coachDataDesktop.nextIndo
                                        : coachDataDesktop.nextEng
                                    }
                                    <div className="right-arr"><MdKeyboardArrowRight /></div>
                                </div>
                            </>
                        ) : (
                            <div className="custom-bet" onClick={handleDone}>
                                {language === 'id'
                                    ? coachDataDesktop.doneIndo
                                    : coachDataDesktop.doneEng
                                }
                            </div>
                        )}
                    </div>
                    <span className="custom-tooltip-arrow"></span>
                </div>
            )
                : (
                    <div className="custom-tooltip"
                        onClick={(e) => e.stopPropagation()} // Prevent event bubbling
                    >
                        <div className="quick-tip">
                            <TbBulb /><span>{`Quick tip ${clickStep}`}/{depositUrl ? 13 : 12}</span>
                        </div>
                        <div className="text">
                            {language === 'id'
                                ? coachDataMobile[currentStep]?.headerIndo
                                : coachDataMobile[currentStep]?.headerEng
                            }
                        </div>
                        <p className="market-bet">
                            {language === 'id'
                                ? coachDataMobile[currentStep]?.descriptionIndo
                                : coachDataMobile[currentStep]?.descriptionEng
                            }
                        </p>
                        <div className="custom-action">
                            {currentStep < valueDone ? (
                                <>
                                    <div className="custom-bet" onClick={handleDone}>
                                        {language === 'id'
                                            ? coachDataMobile.skipAllIndo
                                            : coachDataMobile.skipAllEng
                                        }
                                    </div>
                                    <div className="custom-bet" onClick={handleNext}>
                                        {language === 'id'
                                            ? coachDataMobile.nextIndo
                                            : coachDataMobile.nextEng
                                        }
                                        <div className="right-arr"><MdKeyboardArrowRight /></div>
                                    </div>
                                </>
                            ) : (
                                <div className="custom-bet" onClick={handleDone}>
                                    {language === 'id'
                                        ? coachDataMobile.doneIndo
                                        : coachDataMobile.doneEng
                                    }
                                </div>
                            )}
                        </div>
                        <span className="custom-tooltip-arrow"></span>
                    </div>
                )
        }

        </>
    )
}

export default CoachMarkPopup